@if (!hasGeneralData) {
  <div dsContent [contentPath]="'claims.checkBackSoonText'" class="row pad-bottom-20"></div>
} @else {
  <div class="row">
    <div class="row bottom-dashed-border pad-bottom-20">
      <div class="float-left">
        <strong dsContent [contentPath]="'claims.dateFiledText'"></strong>
      </div>
      <div class="float-right" data-cy="dateFiled">{{ claimGeneralData.dateFiled }}</div>
    </div>
    <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
      <div class="float-left">
        <strong dsContent [contentPath]="'claims.dateAndTimeIncidentText'"></strong>
      </div>
      <div class="float-right">
        <span data-cy="incidentDate">{{ claimGeneralData.incidentDate }}</span> <br />
        <span data-cy="incidentTime">{{ claimGeneralData.timeOfIncident }}</span>
      </div>
    </div>
    @if (claimType === claimDetailConstant.AUTO) {
      <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
        <div class="float-left">
          <strong dsContent [contentPath]="'claims.vehicleText'"></strong>
        </div>
        @if (!!claimGeneralData.vehicle?.vin) {
          <div class="float-right" data-cy="vehicleName">
            {{
              claimGeneralData.vehicle?.year +
                ' ' +
                claimGeneralData.vehicle?.make +
                ' ' +
                claimGeneralData.vehicle?.model
            }}
          </div>
        }
        @if (!claimGeneralData.vehicle?.vin) {
          <div dsContent [contentPath]="'claims.fnol.vehicleNotOnPolicy'" class="float-right"></div>
        }
      </div>
    }
    @if (claimType === claimDetailConstant.PROPERTY) {
      <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
        <div class="float-left">
          <strong dsContent [contentPath]="'claims.propertyText'"></strong>
        </div>
        <div class="float-right">
          @if (claimGeneralData?.lossLocationAddress?.addr1) {
            <span data-cy="propertyName"
              >{{ claimGeneralData?.lossLocationAddress?.addr1 }} <br />
            </span>
          }
          <span>{{
            claimGeneralData?.lossLocationAddress?.city +
              ', ' +
              claimGeneralData?.lossLocationAddress?.state +
              ' ' +
              claimGeneralData?.lossLocationAddress?.zip5
          }}</span>
        </div>
      </div>
    }
    @if (claimType === claimDetailConstant.PROPERTY || claimGeneralData.vehicle?.vin) {
      <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
        <div class="float-left">
          <strong dsContent [contentPath]="'claims.policyText'"></strong>
        </div>
        <div class="float-right" data-cy="policyNumber">
          {{ claimGeneralData.policyNumber | prettyPolicyNum }}
        </div>
      </div>
    }
    @if (claimGeneralData?.claimDescription) {
      <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
        <div class="float-left">
          <strong dsContent [contentPath]="'claims.incidentDescriptionText'"></strong>
        </div>
        <div class="float-right">{{ claimGeneralData?.claimDescription }}</div>
      </div>
    }
    @if (claimGeneralData?.lossDescription) {
      <div class="row bottom-dashed-border pad-bottom-20 pad-top-20">
        <div class="float-left">
          <strong dsContent [contentPath]="'claims.typeOfIncidentText'"></strong>
        </div>
        <div class="float-right" data-cy="incidentType">
          {{ claimGeneralData?.lossDescription }}
        </div>
      </div>
    }
    @if (claimType === claimDetailConstant.AUTO) {
      <div class="row pad-bottom-20 pad-top-20">
        <div class="float-left">
          <strong dsContent [contentPath]="'claims.locationText'"></strong>
        </div>
        <div class="float-right" data-cy="location">
          @if (claimGeneralData?.lossLocationAddress?.addr1) {
            <span>{{ claimGeneralData?.lossLocationAddress?.addr1 }} <br /> </span>
          }
          <span>{{
            claimGeneralData?.lossLocationAddress?.city +
              ', ' +
              claimGeneralData?.lossLocationAddress?.state +
              ' ' +
              claimGeneralData?.lossLocationAddress?.zip5
          }}</span>
        </div>
      </div>
    }
  </div>
}
